/**
 * Build-time configuration (Vite `VITE_*` variables, baked into the static bundle).
 * Defaults target the local dev stack (`pnpm dev:stack`, see infra/compose/README.md).
 */
export interface AdminConfig {
  /** API base incl. version prefix. Default `/v1` (same origin, proxied to the API). */
  apiBaseUrl: string;
  /** Keycloak realm issuer. */
  oidcAuthority: string;
  oidcClientId: string;
  /** Origin the app is served from (redirect URIs are derived from it). */
  appOrigin: string;
  /** Operator_Console URL shown to outlet/dealer staff who sign in here. */
  operatorUrl: string;
}

type Env = Partial<Record<string, string | boolean | undefined>>;

const str = (env: Env, key: string, fallback: string): string => {
  const v = env[key];
  return typeof v === 'string' && v.trim() !== '' ? v.trim() : fallback;
};

export function readConfig(env: Env, appOrigin: string): AdminConfig {
  return {
    apiBaseUrl: str(env, 'VITE_API_BASE_URL', '/v1'),
    oidcAuthority: str(env, 'VITE_OIDC_AUTHORITY', 'https://auth.localhost/realms/macksons'),
    oidcClientId: str(env, 'VITE_OIDC_CLIENT_ID', 'admin-portal'),
    appOrigin,
    operatorUrl: str(env, 'VITE_OPERATOR_URL', 'https://ops.localhost'),
  };
}

/** Resolves a relative API base (`/v1`) against the app origin for openapi-fetch. */
export function absoluteApiBase(config: AdminConfig): string {
  return new URL(config.apiBaseUrl, `${config.appOrigin}/`).toString().replace(/\/+$/, '');
}
